const Matrics = () => {
    return (
        <div className="metrics-tab-content ">
            <div className="alert alert-info">
                <small>Metrics data integration pending. This tab will show client-specific analytics.</small>
            </div>
        </div>
    )
}
export default Matrics;